export const environment = {
  production: true,
  API: 'https://api.govworks.com/api/'
}
